import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button, Tooltip } from "react-bootstrap";
import { Fade } from "react-reveal";
import Selecttokenmod from "Component/Modals/Selecttokenmod";
import { useDispatch, useSelector } from "react-redux";
import { deleteProfileImg, getProfile } from "store/actions";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment";
import AssetsList from "./Assets-List";
import { uploadFileRequest, uploadProfileImg } from "store/actions";
import Loader from "Component/Common/Loader";
import ChangePasswordModel from "./changePassword";
import SetPasswordModel from "./Set-password";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";

import Implaceholder from "../../assets/images/implaceholder.png";
import ConfirmScrollLockModal from "Component/Common/Confirm-ScrollLock-Model";
import EditProfileModal from "./edit-profile";
import { tr } from "@lifi/widget/i18n";
import Pencil from "../../assets/images/pencil.png";
import { useKycStatus } from "helpers/custom-hooks";

const Profile = () => {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const dispatch = useDispatch();
  const [copySuccess, setCopySuccess] = useState();
  const [isRefresh, setIsRefresh] = useState(false);
  const isVerified = useKycStatus();

  const copyTextRef = useRef(null);
  const [userInfo, setUserInfo] = useState();
  const { user } = useSelector(({ Login }) => Login);
  const { loading } = useSelector(({ File }) => File);
  const [showModal, setshowModal] = useState(false);
  const [isShowPassword, setShowPassword] = useState(false);

  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const [isEditProfile, setEditProfile] = useState(false);

  const [isRemoveImg, setRemoveImg] = useState(false);

  const toastr = useToastr();

  useEffect(() => {
    if (lang == "ar") {
      setCopySuccess(t("ينسخ"));
    } else {
      setCopySuccess(t("Copy"));
    }
  }, []);

  const [file, setFile] = useState();
  const [profileImgId, setProfileImgId] = useState();

  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }

  /**
   * Used for get the user profile details
   */
  const getProfileFunc = () => {
    const callBack = (response) => {
      if (response.status == "success") {
        setUserInfo(response?.data);
        setFile(response?.data?.profileImage?.link);
        setProfileImgId(response?.data?.profileImage?._id);
      }
    };
    dispatch(getProfile({ id: user?._id }, callBack));
  };

  useEffect(() => {
    if (user?._id) {
      getProfileFunc();
    }
  }, []);

  function copyToClipboard(e) {
    copyTextRef.current.select();
    document.execCommand(t("copy"));
    e.target.focus();
    setCopySuccess(t("copied"));
    setTimeout(() => {
      if (lang == "ar") {
        setCopySuccess(t("ينسخ"));
      } else {
        setCopySuccess(t("Copy"));
      }
    }, 5000);
  }

  /**
   * Used for upload or change profile image
   */
  const onUploadDocFile = (name, file) => {
    const ext = file.name.split(".").pop();
    //checking extension
    if (!["png", "jpg", "jpeg"].includes(ext)) {
      toastr.error("Only .png,.jpg,.jpeg  extension allow!!");
      return;
    }
    if (file?.size >= 5242880) {
      toastr.error("Maximum upload file size: 5MB");
      return;
    }
    if (file) {
      dispatch(uploadFileRequest({ file: file }, uploadFileSuccess(name)));
    }
  };

  const uploadFileSuccess = (name) => (response) => {
    if (response.status == "success") {
      setFile(response?.data?.link);

      const callback = (response) => {
        if (response.status == "success") {
          setProfileImgId(response?.data?.profileImage?._id);
          toastr.success(t("profile_img_updqated"));
        }
      };
      dispatch(
        uploadProfileImg(
          { _id: user?._id, profileImage: response?.data?._id },
          callback
        )
      );
    }
  };

  const onDeleteProfileImg = () => {
    setRemoveImg(true);
  };

  const onConfirm = () => {
    setRemoveImg(false);
    const callback = (response) => {
      if (response.status == "success") {
        toastr.success(t("profile_img_removed"));
        setFile("");
      }
    };
    dispatch(deleteProfileImg({ profileImageId: profileImgId }, callback));
  };
  /**
   * Used for refresh the assets list
   */
  const handleRefresh = () => {
    setIsRefresh(true);
    getProfileFunc();
  };

  const handlePassword = () => {
    setshowModal(true);
  };

  const handleSetPassword = () => {
    setShowPassword(true);
  };

  const handleEdit = () => {
    setEditProfile(true);
  };
  /**
   * Used for render the UI on whole profile of user
   */

  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />

      <section className="home_banner_main sellpagetwo position-relative">
        {loading && <Loader />}

        <ChangePasswordModel
          show={showModal}
          onHide={() => setshowModal(!showModal)}
        />
        <SetPasswordModel
          show={isShowPassword}
          onHide={() => setShowPassword(!isShowPassword)}
        />
        <ConfirmScrollLockModal
          show={isRemoveImg}
          onHide={() => setRemoveImg(!isRemoveImg)}
          onConfirm={onConfirm}
        />

        <EditProfileModal
          show={isEditProfile}
          onHide={() => setEditProfile(!isEditProfile)}
          onApiCall={getProfileFunc}
        />

        <div className="top_circle"></div>
        <section className="detailsbox">
          <Container>
            <Row>
              <Col lg={4} className="my-2">
                <div className="details_box_inner text-start w-100">
                  <div className="d-flex align-items-center gap-1 justify-content-center top py-2 text-center border-bottom">
                    <h5 className="m-0 py-2 fw-bold">{t("user_profile")}</h5>
                    <Button onClick={handleEdit} className="edit_btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#000"
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83l3.75 3.75l1.83-1.83a.996.996 0 0 0 0-1.41"
                        />
                      </svg>
                    </Button>
                  </div>

                  <Col lg={12}>
                    <div className="text-center mt-4">
                      <div className="user_upload position-relative">
                        {!file && (
                          <label>
                            <input
                              type="file"
                              onChange={(e) =>
                                onUploadDocFile("iCardImg", e.target.files[0])
                              }
                              accept="image/png, image/jpeg"
                            />
                          </label>
                        )}

                        <img src={file ? file : Implaceholder} alt="" />

                        {!file ? (
                          <Link
                            to=""
                            className="d-flex align-items-center justify-content-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="49"
                              height="49"
                              viewBox="0 0 49 49"
                              fill="none"
                            >
                              <g filter="url(#filter0_d_284_1520)">
                                <path
                                  d="M24.5 40C34.7173 40 43 31.7173 43 21.5C43 11.2827 34.7173 3 24.5 3C14.2827 3 6 11.2827 6 21.5C6 31.7173 14.2827 40 24.5 40Z"
                                  fill="#FF0000"
                                />
                              </g>
                              <path
                                d="M26.5899 22.6416C26.5899 23.1024 26.4533 23.5528 26.1973 23.9359C25.9413 24.319 25.5775 24.6176 25.1518 24.7939C24.7261 24.9703 24.2577 25.0164 23.8058 24.9265C23.3539 24.8366 22.9388 24.6147 22.613 24.2889C22.2872 23.9631 22.0653 23.548 21.9754 23.0961C21.8855 22.6442 21.9317 22.1758 22.108 21.7501C22.2843 21.3244 22.5829 20.9606 22.966 20.7046C23.3491 20.4486 23.7995 20.312 24.2603 20.312C24.8782 20.312 25.4707 20.5575 25.9076 20.9943C26.3445 21.4312 26.5899 22.0238 26.5899 22.6416Z"
                                fill="white"
                              />
                              <path
                                d="M22.0868 15.373L20.7575 16.8256H18.4553C18.0704 16.8267 17.7015 16.9801 17.4293 17.2523C17.1572 17.5245 17.0038 17.8933 17.0027 18.2782V26.9938C17.0038 27.3787 17.1572 27.7475 17.4293 28.0197C17.7015 28.2919 18.0704 28.4453 18.4553 28.4464H30.0774C30.4623 28.4453 30.8312 28.2919 31.1033 28.0197C31.3755 27.7475 31.5289 27.3787 31.53 26.9938V18.2782C31.5289 17.8933 31.3755 17.5245 31.1033 17.2523C30.8312 16.9801 30.4623 16.8267 30.0774 16.8256H27.7738L26.4459 15.373H22.0868ZM24.2656 26.2689C23.5474 26.2689 22.8453 26.0559 22.2481 25.6568C21.6509 25.2578 21.1855 24.6907 20.9106 24.0271C20.6357 23.3635 20.5638 22.6334 20.7039 21.9289C20.8441 21.2245 21.1899 20.5774 21.6978 20.0695C22.2057 19.5617 22.8527 19.2158 23.5572 19.0757C24.2616 18.9356 24.9918 19.0075 25.6554 19.2823C26.3189 19.5572 26.8861 20.0226 27.2851 20.6198C27.6841 21.217 27.8971 21.9191 27.8971 22.6374C27.8968 23.6004 27.514 24.5239 26.8331 25.2048C26.1521 25.8858 25.2287 26.2685 24.2656 26.2689Z"
                                fill="white"
                              />
                              <defs>
                                <filter
                                  id="filter0_d_284_1520"
                                  x="0"
                                  y="0"
                                  width="49"
                                  height="49"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feOffset dy="3" />
                                  <feGaussianBlur stdDeviation="3" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_284_1520"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_284_1520"
                                    result="shape"
                                  />
                                </filter>
                              </defs>
                            </svg>
                          </Link>
                        ) : (
                          <Link
                            onClick={onDeleteProfileImg}
                            to=""
                            className="d-flex align-items-center justify-content-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="#FF0000"
                                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10"
                              />
                              <path
                                fill="#fff"
                                d="M8.97 8.97a.75.75 0 0 1 1.06 0L12 10.94l1.97-1.97a.75.75 0 1 1 1.06 1.06L13.06 12l1.97 1.97a.75.75 0 0 1-1.06 1.06L12 13.06l-1.97 1.97a.75.75 0 0 1-1.06-1.06L10.94 12l-1.97-1.97a.75.75 0 0 1 0-1.06"
                              />
                            </svg>
                          </Link>
                        )}
                      </div>
                    </div>

                    <div className="text-center my-3">
                      {userInfo?.isPasswordNull ? (
                        <Link
                          to="#"
                          onClick={handleSetPassword}
                          className="chnage_password"
                        >
                          {t("set_password")}
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          onClick={handlePassword}
                          className="chnage_password"
                        >
                          {t("change_password")}
                        </Link>
                      )}
                    </div>
                  </Col>

                  <div className="CardBody py-3">
                    <Row>
                      <Col lg="6" className="my-2">
                        <p className="m-0 text-muted">{t("name")}</p>
                        <p className="text-dark m-0">
                          <strong>
                            {userInfo?.fname && userInfo?.fname}{" "}
                            {userInfo?.lname && userInfo?.lname}
                          </strong>
                        </p>
                      </Col>
                      <Col lg="12" className="my-2">
                        <p className="m-0 text-muted">{t("email")}</p>
                        <p className="email_text text-dark m-0">
                          <strong>
                            {/* <a href={`mailto:${userInfo?.email}`}> */}
                              {userInfo?.email}
                            {/* </a> */}
                          </strong>
                        </p>
                      </Col>
                      <Col lg="6" className="my-2">
                        <p className="m-0 text-muted">{t("mobile_number")}</p>
                        <p className="text-dark m-0">
                          <strong>
                            {/* <a
                              href={`tel:${userInfo?.countryCode}  ${userInfo?.mobileNumber}`}
                            > */}
                              {`${
                                userInfo?.countryCode
                                  ? userInfo?.countryCode.includes("+")
                                    ? userInfo?.countryCode
                                    : "+" + userInfo?.countryCode
                                  : ""
                              }  ${
                                userInfo?.mobileNumber
                                  ? userInfo?.mobileNumber
                                  : ""
                              }`}
                            {/* </a> */}
                          </strong>
                        </p>
                      </Col>
                      {userInfo?.referral_details?.earned_points && (
                        <Col lg="6" className="my-2">
                          <p className="m-0 text-muted">{t("earned_points")}</p>
                          <p className="text-dark m-0">
                            <strong>
                              {userInfo?.referral_details?.earned_points}
                            </strong>
                          </p>
                        </Col>
                      )}
                      <Col lg="12" className="my-2">
                        <p className="m-0 text-muted">{t("share")}</p>

                        <textarea
                          className="form-control"
                          ref={copyTextRef}
                          value={
                            "https://soorx.com/signup?ref=" +
                            userInfo?.referral_details?.code
                          }
                          readOnly
                        />
                      </Col>
                      <Col lg="12" className="my-2">
                        <div className="d-flex align-items-center">
                          <Button
                            className="d-flex align-items-center justify-content-center copy_btn"
                            onClick={copyToClipboard}
                          >
                            {copySuccess}
                          </Button>
                          {/* <p className="text-success m-0 ms-2">
                            {copySuccess}

                          </p> */}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div></div>
              </Col>

              <Col lg={8} className="my-2">
                {userInfo?.referred && userInfo?.referred.length > 0 && (
                  <div className="cardBox p-3 bg-white">
                    <div className="py-2 my-2">
                      <div className="sectionHead text-start">
                        <h4 className="m-0 py-2 fw-bold">
                          {t("referal_list")}
                        </h4>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-nowrap">
                        <thead>
                          <th>{t("referal_date")}</th>
                          <th>{t("refered_to")} </th>
                          <th>{t("points_erned")}</th>
                        </thead>
                        <tbody>
                          {userInfo?.referred.length > 0 &&
                            userInfo.referred.map((obj) => (
                              <tr>
                                <td>
                                  {moment(obj.referralDate).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td>{obj.referredTo}</td>
                                <td>{obj.pointsEarned}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {isVerified && (
                  <AssetsList
                    vault={userInfo?.vault}
                    handleRefresh={handleRefresh}
                    isRefresh={isRefresh}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </section>
        {/* <div className="bottom_circle"></div> */}
      </section>
    </Fade>
  );
};

export default Profile;
